
export const simulatorRoutes: {
  departure: string;
  destination: string;
  distanceKm: number;
  durationMin: number;
  priceBerline: number;
  priceVan: number;
}[] = [
  { departure: 'Aéroport de Genève', destination: 'Chamonix', distanceKm: 88, durationMin: 75, priceBerline: 250, priceVan: 350 },
  { departure: 'Aéroport de Genève', destination: 'Courchevel', distanceKm: 195, durationMin: 150, priceBerline: 358, priceVan: 480 },
  { departure: 'Aéroport de Genève', destination: 'Val Thorens', distanceKm: 210, durationMin: 165, priceBerline: 401, priceVan: 520 },
  { departure: 'Aéroport de Genève', destination: 'Val d\'Isère', distanceKm: 225, durationMin: 170, priceBerline: 423, priceVan: 550 },
  { departure: 'Aéroport de Genève', destination: 'Tignes', distanceKm: 220, durationMin: 165, priceBerline: 416, priceVan: 540 },
  { departure: 'Aéroport de Genève', destination: 'Méribel', distanceKm: 185, durationMin: 145, priceBerline: 369, priceVan: 490 },
  { departure: 'Aéroport de Genève', destination: 'Morzine', distanceKm: 85, durationMin: 70, priceBerline: 243, priceVan: 340 },
  { departure: 'Aéroport de Genève', destination: 'Annecy', distanceKm: 45, durationMin: 40, priceBerline: 157, priceVan: 220 },
  { departure: 'Aéroport de Genève', destination: 'Megève', distanceKm: 78, durationMin: 70, priceBerline: 235, priceVan: 330 },
  { departure: 'Aéroport de Genève', destination: 'Les Arcs', distanceKm: 200, durationMin: 155, priceBerline: 390, priceVan: 510 },
  { departure: 'Aéroport de Chambéry', destination: 'Courchevel', distanceKm: 110, durationMin: 95, priceBerline: 323, priceVan: 430 },
  { departure: 'Aéroport de Chambéry', destination: 'Val Thorens', distanceKm: 130, durationMin: 110, priceBerline: 393, priceVan: 510 },
  { departure: 'Aéroport de Chambéry', destination: 'Val d\'Isère', distanceKm: 155, durationMin: 130, priceBerline: 393, priceVan: 510 },
  { departure: 'Aéroport de Chambéry', destination: 'Tignes', distanceKm: 150, durationMin: 125, priceBerline: 457, priceVan: 580 },
  { departure: 'Aéroport de Chambéry', destination: 'Méribel', distanceKm: 100, durationMin: 85, priceBerline: 328, priceVan: 440 },
  { departure: 'Aéroport de Chambéry', destination: 'La Plagne', distanceKm: 120, durationMin: 100, priceBerline: 377, priceVan: 490 },
  { departure: 'Aéroport de Chambéry', destination: 'Les Arcs', distanceKm: 125, durationMin: 105, priceBerline: 379, priceVan: 495 },
  { departure: 'Aéroport de Chambéry', destination: 'Les Menuires', distanceKm: 115, durationMin: 100, priceBerline: 357, priceVan: 470 },
  { departure: 'Aéroport de Chambéry', destination: 'Morzine', distanceKm: 165, durationMin: 135, priceBerline: 461, priceVan: 590 },
  { departure: 'Aéroport de Chambéry', destination: 'Lyon Aéroport', distanceKm: 105, durationMin: 70, priceBerline: 235, priceVan: 320 },
  { departure: 'Aéroport de Lyon', destination: 'Courchevel', distanceKm: 230, durationMin: 180, priceBerline: 484, priceVan: 620 },
  { departure: 'Aéroport de Lyon', destination: 'Méribel', distanceKm: 225, durationMin: 175, priceBerline: 495, priceVan: 630 },
  { departure: 'Aéroport de Lyon', destination: 'Val Thorens', distanceKm: 250, durationMin: 195, priceBerline: 518, priceVan: 660 },
  { departure: 'Aéroport de Lyon', destination: 'Val d\'Isère', distanceKm: 280, durationMin: 210, priceBerline: 553, priceVan: 700 },
  { departure: 'Aéroport de Lyon', destination: 'Tignes', distanceKm: 275, durationMin: 205, priceBerline: 541, priceVan: 690 },
  { departure: 'Aéroport de Lyon', destination: 'La Plagne', distanceKm: 240, durationMin: 185, priceBerline: 472, priceVan: 610 },
  { departure: 'Aéroport de Lyon', destination: 'Les Arcs', distanceKm: 245, durationMin: 190, priceBerline: 478, priceVan: 615 },
  { departure: 'Aéroport de Lyon', destination: 'Chamonix', distanceKm: 220, durationMin: 170, priceBerline: 450, priceVan: 580 },
  { departure: 'Aéroport de Grenoble', destination: 'Alpe d\'Huez', distanceKm: 65, durationMin: 55, priceBerline: 139, priceVan: 195 },
  { departure: 'Aéroport de Grenoble', destination: 'Les Deux Alpes', distanceKm: 75, durationMin: 65, priceBerline: 150, priceVan: 210 },
  { departure: 'Aéroport de Grenoble', destination: 'Chamrousse', distanceKm: 35, durationMin: 35, priceBerline: 98, priceVan: 140 },
  { departure: 'Aéroport de Grenoble', destination: 'Villard-de-Lans', distanceKm: 40, durationMin: 40, priceBerline: 110, priceVan: 155 },
  { departure: 'Gare de Moutiers', destination: 'Courchevel', distanceKm: 25, durationMin: 30, priceBerline: 95, priceVan: 135 },
  { departure: 'Gare de Moutiers', destination: 'Méribel', distanceKm: 20, durationMin: 25, priceBerline: 85, priceVan: 120 },
  { departure: 'Gare de Moutiers', destination: 'Val Thorens', distanceKm: 38, durationMin: 40, priceBerline: 120, priceVan: 170 },
  { departure: 'Gare de Moutiers', destination: 'Les Menuires', distanceKm: 30, durationMin: 35, priceBerline: 105, priceVan: 150 },
  { departure: 'Gare de Bourg Saint Maurice', destination: 'Les Arcs', distanceKm: 15, durationMin: 20, priceBerline: 75, priceVan: 110 },
  { departure: 'Gare de Bourg Saint Maurice', destination: 'Val d\'Isère', distanceKm: 32, durationMin: 35, priceBerline: 110, priceVan: 155 },
  { departure: 'Gare de Bourg Saint Maurice', destination: 'Tignes', distanceKm: 30, durationMin: 30, priceBerline: 105, priceVan: 150 },
  { departure: 'Gare de Bourg Saint Maurice', destination: 'La Rosière', distanceKm: 22, durationMin: 25, priceBerline: 90, priceVan: 130 },
];

export const departures = [
  'Aéroport de Genève',
  'Aéroport de Chambéry',
  'Aéroport de Lyon',
  'Aéroport de Grenoble',
  'Gare de Moutiers',
  'Gare de Bourg Saint Maurice',
];

export const vehicleTypes = [
  {
    id: 'berline',
    name: 'Mercedes Classe E',
    type: 'Berline',
    passengers: 3,
    luggage: 3,
    hourlyRate: 85,
    image: 'https://public.readdy.ai/ai/img_res/d2f1ff2335cfb58210f01c5fbcc34a99.jpg',
  },
  {
    id: 'van',
    name: 'Mercedes Classe V',
    type: 'Van',
    passengers: 7,
    luggage: 8,
    hourlyRate: 120,
    image: 'https://readdy.ai/api/search-image?query=elegant%20black%20mercedes%20v%20class%20van%20side%20view%20on%20clean%20white%20studio%20background%20luxury%20executive%20van%20professional%20automotive%20photography%20minimalist%20style&width=400&height=250&seq=van-sim-001&orientation=landscape',
  },
];

export const supplements = [
  { id: 'siege-bebe', label: 'Siège bébé', price: 15, icon: 'ri-user-heart-line' },
  { id: 'ski', label: 'Transport de skis', price: 0, icon: 'ri-snowflake-line' },
  { id: 'nuit', label: 'Supplément nuit (22h-6h)', price: 30, icon: 'ri-moon-line' },
  { id: 'arret', label: 'Arrêt intermédiaire', price: 25, icon: 'ri-map-pin-add-line' },
  { id: 'accueil', label: 'Accueil panneau nominatif', price: 0, icon: 'ri-file-user-line' },
];

export const faqPricing = [
  {
    question: 'Les prix affichés sont-ils définitifs ?',
    answer: 'Oui, nos prix sont fixes et tout compris. Pas de frais cachés, pas de supplément pour les bagages standards, le WiFi ou les rafraîchissements. Le prix affiché est le prix final.',
  },
  {
    question: 'Comment fonctionne le simulateur de prix ?',
    answer: 'Sélectionnez votre lieu de départ, votre destination, le type de véhicule et les options souhaitées. Le prix s\'affiche instantanément. Vous pouvez ensuite réserver directement via WhatsApp ou notre formulaire.',
  },
  {
    question: 'Y a-t-il un supplément pour les trajets de nuit ?',
    answer: 'Un supplément de 30 € s\'applique pour les prises en charge entre 22h et 6h du matin. Ce supplément est clairement indiqué dans le simulateur.',
  },
  {
    question: 'Puis-je réserver un aller-retour ?',
    answer: 'Absolument ! Pour un aller-retour, le prix est simplement doublé. Vous bénéficiez d\'une réduction de 5% sur le trajet retour. Contactez-nous pour un devis personnalisé.',
  },
  {
    question: 'Que comprend le tarif de mise à disposition ?',
    answer: 'La mise à disposition est facturée 85 €/h en berline et 120 €/h en van, avec un minimum de 3 heures. Le chauffeur reste à votre disposition pendant toute la durée réservée.',
  },
  {
    question: 'Les enfants paient-ils un supplément ?',
    answer: 'Non, les enfants ne paient pas de supplément. Nous fournissons des sièges bébé et rehausseurs sur demande pour 15 € par siège, pour garantir la sécurité de vos enfants.',
  },
];
